/**
 * Fire-and-forget analytics event to the BFF, which writes it to BigQuery.
 * Failures are silently ignored — analytics must never break the UI.
 */
export function trackEvent(
  eventType: string,
  properties?: Record<string, unknown>,
): void {
  fetch("/api/analytics", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ eventType, properties }),
  }).catch(() => {
    // Intentionally swallowed
  });
}
